import { RootState } from 'app/rootReducer'

export const selectedStateSelector = (state: RootState) =>
  state.requestForProposalList?.state || 'published'

export const rfpListIsLoadingSelector = (state: RootState) =>
  state.requestForProposalList?.meta?.isLoading

export const rfpListSelector = (state: RootState) =>
  Object.values(state.requestForProposalList?.list || {})

export const rfpDetailIsLoadingSelector = (state: RootState) =>
  state.requestForProposalList?.detail?.meta?.isLoading

export const rfpDetailIsExportingSelector = (state: RootState) =>
  state.requestForProposalList?.detail?.meta?.isExporting

export const rfpDetailSelector = (
  state: RootState
): RequestForProposalDetail | undefined =>
  state.requestForProposalList?.detail?.rfp

export const rfpDetailErrorSelector = (state: RootState): string | null =>
  state.requestForProposalList.detail.meta.error

export const rfpDetailIsUpdatingSelector = (state: RootState): boolean =>
  !!state.requestForProposalList?.detail.rfp?.meta.isUpdating
